<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.params.plate">
    <vehicle-details-content slot-scope="{data}" :vehicle="data"></vehicle-details-content>
  </l-cache>
</template>

<script>
import VehicleDetailsContent from './vehicleDetailsContent'

export default {
  name: 'VehicleStatisticDetails',
  components: {VehicleDetailsContent},
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('pass/searchVehicles', {plate: key})
      if (items.length) {
        //console.log(items)
        return items[0]
      }
      else {
        throw Error('未找到该车辆')
      }
    }
  }
}
</script>

<style scoped>

</style>
